// extracted by mini-css-extract-plugin
export var border = "BorderImage-module--border--55532";
export var image = "BorderImage-module--image--b4c97";
export var large = "BorderImage-module--large--b3a59";